import PropTypes from 'prop-types';
import React from 'react';
import style from './CandlePatternButton.module.css';

export const CandlePatternButton = ({ clickHandler, label, fontSize }) => {
  return (
    <button
      style={{ fontSize }}
      onClick={clickHandler}
      className={style.button}
    >
      {label}
    </button>
  );
};

CandlePatternButton.propTypes = {
  clickHandler: PropTypes.func,
  fontSize: PropTypes.string,
  label: PropTypes.string
};

